import Vue from 'vue';
import axios from 'axios';

export const llpg = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    SEARCH ({}, {key, query}) {
      return new Promise((resolve, reject) => {
        const url = `${process.env.VUE_APP_SEARCH_URL}/${key}/llpg/v2?query=${query}`;

        axios.get(url).then((res) => {
          console.dir(res);
          resolve(res.data.data);
        });
      });
    }
  },
  getters: {}
};
